/** @flow */
import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Logo from 'common/components/Logo';
import PropositionDetailsContent from 'common/modules/proposition/components/PropositionDetailsContent';
import FixedActionsBar from 'common/components/FixedActionsBar';
import Proposition from 'common/modules/proposition/domain/proposition';
import LoadingSpinner from 'common/components/LoadingSpinner';
import Page from 'common/components/Page';
import Advertiser from 'common/modules/advertiser/domain/Advertiser';
import { getToken } from 'advertisers/modules/authentication/selectors/sessionSelectors';

import PropositionDetailsActions from './components/PropositionDetailsActions';
import { propositionHasActions } from './decorators/withPropositionActions';
import PageContainer from '../../components/PageContainer';
import { getCurrentAdvertiser } from '../advertiser/selectors/advertiserSelectors';
import PropositionAPI from './services/PropositionAPI';

const StyledPage = styled(Page)`
  padding-bottom: 80px;
`;

const CenterWrapper = styled.div`
  justify-content: center;
  text-align: center;
  margin-top: 25vh;
  margin-left: auto;
  margin-right: auto;
`;

const RightLogo = styled(Logo)`
  display: block;
  margin-left: auto;
`;

type Props = {
  advertiser: Advertiser;
  token: string;

  match: any;
  t: any;
  theme: any;
}

type State = {
  fetchingError: boolean;
  proposition: ?Proposition;
}

class PropositionDetailPage extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    (this: any).onPropositionChange = this.onPropositionChange.bind(this);

    this.state = {
      proposition: undefined,
      fetchingError: false,
    };
  }

  componentDidMount() {
    const { advertiser, token } = this.props;
    const reference = this.props.match.params.reference;
    PropositionAPI.fetchProposedCampaign(advertiser.reference, token, reference)
      .then(proposition => this.setState({ proposition, fetchingError: false }))
      .catch(() => {
        this.setState({ fetchingError: true });
      });
  }

  onPropositionChange(proposition: Proposition) {
    this.setState({ proposition });
  }

  render() {
    const { proposition, fetchingError } = this.state;
    const { t, theme } = this.props;
    const title = (proposition && proposition.title) || t('propositions');

    return (
      <PageContainer>
        <StyledPage
          fluid
          hideTitle
          title={title.toUpperCase()}
        >
          <RightLogo src={proposition && proposition.radio && proposition.radio.logo} />
          { proposition &&
            <div>
              <PropositionDetailsContent proposition={proposition} />
              { propositionHasActions(proposition) &&
                <FixedActionsBar position="BOTTOM" style={{ width: '80%' }}>
                  <div />
                  <PropositionDetailsActions proposition={proposition} onChange={this.onPropositionChange} />
                </FixedActionsBar>
              }
            </div>
          }
          { !proposition &&
            <CenterWrapper>
              { !fetchingError &&
                <LoadingSpinner size="medium" />
              }
              { fetchingError &&
                <span style={theme.fonts.style.smallCardTitle}>
                  {t('noRightsForPropositionOrNotFound')}
                </span>
              }
            </CenterWrapper>
          }
        </StyledPage>
      </PageContainer>
    );
  }
}

function mapStateToProps(state) {
  return {
    advertiser: getCurrentAdvertiser(state),
    token: getToken(state),
  };
}

export default translate('commonSales')(connect(mapStateToProps)(withTheme(withRouter(PropositionDetailPage))));



// WEBPACK FOOTER //
// ./src/advertisers/modules/propositions/PropositionDetailPage.js